import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#FDF8F5] text-slate-900 px-6" data-testid="not-found">
      <div className="font-heading text-6xl font-bold mb-2">404</div>
      <div className="text-slate-600 mb-6">Page not found.</div>
      <Link to="/" className="brut-btn text-sm" data-testid="not-found-home">Back home</Link>
    </div>
  );
}
